<template>
  <VDialog v-model="dialog" width="600px">
    <VCard>
      <VBtn
        absolute
        icon
        right
        style="right: 0"
        class="mt-0 pb-0"
        @click="close"
      >
        <VIcon>mdi-close</VIcon>
      </VBtn>
      <VCardTitle class="text-center" style="color: #fdcc05">{{
        $t("partialAdmission")
      }}</VCardTitle>
      <VCardText>
        <ValidationObserver v-slot="{ handleSubmit }" ref="formObs">
          <form @submit.prevent="handleSubmit(send)">
            <div class="py-2">
              <CustomTextTextarea
                rules="required"
                :label="$t('leaveComment')"
                class="user_input"
                v-model="contractItemDecision.description"
              ></CustomTextTextarea>
            </div>
            <VFileInput
              v-model="contractItemDecision.files"
              :label="$t('attachFile')"
            ></VFileInput>
            <div class="text-right">
              <VBtn type="submit" color="primary">{{ $t("send") }}</VBtn>
            </div>
          </form>
        </ValidationObserver>
      </VCardText>
    </VCard>
  </VDialog>
</template>

<script>
const DEFAULT_CONTRACT_ITEM_DECISION = {
  userAgreementId: null,
  files: null,
  description: null,
};
export default {
  data() {
    return {
      dialog: false,
      contractItemDecision: {
        ...DEFAULT_CONTRACT_ITEM_DECISION,
      },
      confirmDialog: false,
    };
  },
  watch: {
    dialog(val) {
      if (!val) this.clear();
    },
  },
  methods: {
    clear() {
      this.contractItemDecision = {
        ...DEFAULT_CONTRACT_ITEM_DECISION,
      };
      this.$refs.formObs.reset();
    },
    async send() {
      this.showLoading();
      try {
        const formData = new FormData();
        const { userAgreementId, description, files } =
          this.contractItemDecision;
        formData.append("userAgreementId", userAgreementId);
        formData.append("reason", description);
        formData.append("files", files);

        await this.$http.post("/user-agreement/part-accept", formData);
        this.$emit("updateTableData");
        this.setSuccess({ text: this.$t("successfullySent") });
        this.close();
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    open(id) {
      this.contractItemDecision.userAgreementId = id;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
  },
};
</script>
